import React, { FC, useMemo } from 'react'
import dayjs from '../../utils/dayjs'

interface IDateFormat {
    date: string,
}

const DateFormat: FC<IDateFormat> = ({ date }) => {
    const formatDate = useMemo(() => dayjs(date).format('DD.MM.YYYY'), [date])
    return <time>{formatDate}</time>
}

export default DateFormat